import type { JSX } from 'react';
import { useEffect, useState, memo } from 'react';

import * as logger from 'pkg/logger';

import Embed from 'components/formatted-content/Embed';
import { addFormatter } from 'components/formatted-content/FormattedContent';

interface VimeoOEmbedProps {
	url: string;
}

const VimeoOEmbed = memo(({ url }: VimeoOEmbedProps): JSX.Element => {
	const [resource, setResource] = useState<JSONObject>();

	useEffect(() => {
		const embed = async () => {
			try {
				const request = await fetch(
					`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(url)}`
				);

				if (request.ok) {
					const response = await request.json();

					if (response.html) {
						setResource(response);
					}
				}
			} catch (e) {
				logger.error(new Error('Vimeo oEmbed failed', { cause: e }));
			}
		};

		embed();
	}, [url]);

	if (resource) {
		return <Embed html={resource.html as string} />;
	}

	return (
		<a href={url} target="_blank" rel="noreferrer noopener">
			{url}
		</a>
	);
});

addFormatter('vimeo', {
	isEmbed: true,
	selector: /(^https?:\/\/?(?:www.)?(?:vimeo.com)(?:\S+)?)$/gi,
	decorator: (guid: string, match: string): JSX.Element => (
		<VimeoOEmbed key={guid} url={match} />
	),
});
